import { render, staticRenderFns } from "./SignupOmniTalk.vue?vue&type=template&id=2dc8aa2e&scoped=true"
import script from "./SignupOmniTalk.vue?vue&type=script&lang=js"
export * from "./SignupOmniTalk.vue?vue&type=script&lang=js"
import style0 from "./SignupOmniTalk.vue?vue&type=style&index=0&id=2dc8aa2e&prod&scoped=true&lang=css"
import style1 from "./SignupOmniTalk.vue?vue&type=style&index=1&id=2dc8aa2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8aa2e",
  null
  
)

export default component.exports